import { useParams } from "wouter";
import { useGangContext } from "./useGang.ts";

export function useVehicle() {
  const { gang, readOnly } = useGangContext();
  const { vehicleId } = useParams<{ vehicleId: string }>();
  const lookup = gang.getVehicle(vehicleId);
  const vehicle = lookup.valueOrNull();
  return { readOnly, lookup, vehicle };
}
